import { Box, CardMedia, Stack, Typography } from '@mui/material';
import React from 'react'
import { fatchFromApi } from '../utils/fatchFromApi';
import ReactPlayer from 'react-player';
import { Link, useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { demoProfilePicture } from '../utils/constants';
import { Videos } from './index'

const VideoDetail = () => {
  const {id} = useParams();
  const [videoDetail, setVideoDetail] = React.useState();
  const [videos, setVideos] = React.useState();

  React.useEffect(() => {
    fatchFromApi(`videos?part=snippet,statistics&id=${id}`).then((data) => setVideoDetail(data.items[0]));

    fatchFromApi(`search?part=snippet&relatedToVideoId=${id}&type=video`).then((data) => setVideos(data.items))
  },[id]);

  if (!videoDetail?.snippet) return 'Loading...'

  return (
    <Box minHeight="95vh">
      <Stack direction={{ xs: "column", md: "row" }}>
        <Box flex={1}>
          <Box sx={{ width: "100%", position: "sticky", top: "86px" }}>
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${id}`}
              className="react-player"
              controls
            />
            <Typography color="#fff" variant="h5" fontWeight="bold" p={2}>
              {videoDetail.snippet.title}
            </Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ color: "#fff" }}
              px={2}
              py={1}
              display= 'flex'
              
            >
              <Link to={`/channel/${videoDetail.snippet.channelId}`} >
                <Stack direction='row' alignItems='center' display='flex' justifyContent='center'>
                <CardMedia
                  image={
                    videoDetail?.snippet?.thumbnails?.high?.url ||
                    demoProfilePicture
                  }
                  alt={videoDetail?.snippet?.title}
                  sx={{
                    borderRadius: "50%",
                    height: "40px",
                    width: "40px",
                    mb: 2,
                    border: "1px solid #e3e3e3",
                  }}
                  />
                <Typography color="#fff" ml='10px' variant={{ sm: "subtitle", md: "h6" }}>
                  {videoDetail.snippet.channelTitle}
                  <CheckCircleIcon
                    sx={{ fontSize: "12px", ml: "5px", color: "gray" }}
                    />
                </Typography>
              </Stack>
              </Link>
               <Stack direction='row' gap='20px' alignItems='center'>
                 <Typography>
                   {parseInt(videoDetail.statistics.viewCount).toLocaleString()} views
                 </Typography>
                 <Typography>
                   {parseInt(videoDetail.statistics.likeCount).toLocaleString()} likes
                 </Typography>
               </Stack>
            </Stack>
          </Box>
        </Box>
        <Box px={2} py={{md: 1, xs: 5}} justifyContent='center' alignItems='center'>
          <Videos videos={videos} direction='column' />
        </Box>
      </Stack>
    </Box>
  );
}

export default VideoDetail